var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":require("./img/map.png"),"alt":""},on:{"click":_vm.toPre}})])
}
var staticRenderFns = []

export { render, staticRenderFns }